import { Injectable } from '@angular/core';
import { ConfigService } from '../../config.service';
import { ConfigDataStoreService } from './config-data-store.service';
import { UserService } from '../../../shared/services/user.service';
import { SystemConfigDTO } from '../../../shared/dto/system-config/system-config-dto';
import { SystemConfigResponseDTO } from '../../../shared/dto/system-config/system-config-response-dto';
import { AdditionalService } from '../../../shared/dto/system-config/additional-service';

@Injectable()
export class AdditionalServicesDataStoreService extends ConfigDataStoreService<AdditionalService> {

  constructor(configService: ConfigService, userService: UserService) {
    super(configService, userService, 'ADDITIONAL_SERVICE');
  }

  public create(data: AdditionalService): Promise<SystemConfigResponseDTO> {
    return null;
  }

  public update(data: AdditionalService): Promise<SystemConfigResponseDTO> {
    const configObject: SystemConfigDTO = { userId: this.user.id, type: this.type, additionalServiceDTO: data };
    const response = this.configService.updateSystemConfig(configObject);
    response.then(res => {
      this.dataSetPromise.then(dataSet => {
        const index = dataSet.findIndex(dataPoint => dataPoint.id === res.configValueDTO.id);
        dataSet[index] = res.configValueDTO as AdditionalService;
        this.dataSet.next(dataSet);
        this.dataSetPromise = Promise.resolve(dataSet);
      });
    });

    return response;
  }

  public find(id: number): Promise<AdditionalService> {
    return Promise.resolve(this.dataSetPromise.then(ds => {
      return ds.find(d => d.id === id);
    }));
  }
}
